/* OMBA complementos v3. Preparado: requiere disponibilidad pública y precio exacto. Usa la cola y el carrito reales del runtime v8. */
(function (global) {
  'use strict';
  const variant = item => String(item.variant_id || item.id);
  const quantity = (cart, id) => (cart.items || []).filter(item => variant(item) === String(id)).reduce((n, item) => n + Number(item.quantity), 0);
  const ownLines = (cart, candidate, context) => (cart.items || []).filter(item => variant(item) === String(candidate.variantId) && item.properties?._omba_complement === context);
  const subtotal = (cart, id) => (cart.items || []).filter(item => variant(item) === String(id)).reduce((n, item) => n + Number(item.final_line_price), 0);
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const candidatesFor = cfg => (cfg.selectedCandidates || [cfg.selectedCandidate]).map(key => cfg.candidates[key]).filter(Boolean);
  // The card is 56px; a 112px CDN image is sharp on Retina without fetching the master.
  function thumbnail(photo) {
    if (!photo) return '';
    const [base, query = ''] = String(photo).split('?');
    const parts = query.split('&').filter(part => part && !/^width=/.test(part));
    parts.push('width=112');
    return base + '?' + parts.join('&');
  }
  function cardMarkup(cfg, candidate, product, state) {
    const id = 'omba-complement-' + cfg.context + '-' + candidate.variantId;
    const photo = thumbnail(product.featured_image || product.images?.[0]);
    const description = candidate.cardDescription || candidate.description + ' · ' + candidate.quantity + (candidate.quantity === 1 ? ' frasco' : ' frascos');
    const price = new Intl.NumberFormat(cfg.locale, {style:'currency', currency:cfg.currency}).format(candidate.offerTotalCents / 100);
    return (state.omitHeading ? '' : '<p class="omba-complement-heading">'+escape(cfg.blockTitle || 'Completa tu rutina')+'</p>') +
      '<label class="omba-complement-card'+(state.checked ? ' is-selected' : '')+'" aria-busy="'+Boolean(state.disabled)+'">' +
      '<input type="checkbox" data-complement-toggle="'+escape(candidate.variantId)+'" aria-labelledby="'+escape(id)+'-title" aria-describedby="'+escape(id)+'-description '+escape(id)+'-price" '+(state.checked ? 'checked ' : '')+(state.disabled ? 'disabled ' : '')+'>' +
      (photo ? '<img src="'+escape(photo)+'" alt="" width="56" height="56" loading="eager" decoding="async">' : '<span class="omba-complement-photo" aria-hidden="true"></span>') +
      '<span class="omba-complement-copy"><strong id="'+escape(id)+'-title">'+escape(candidate.cardTitle || candidate.title)+'</strong><span id="'+escape(id)+'-description">'+escape(description)+'</span></span>' +
      '<strong class="omba-complement-price" id="'+escape(id)+'-price">'+escape(price)+'</strong></label>';
  }
  function validateProduct(product, candidate) {
    const v = product?.variants?.find(item => String(item.id) === String(candidate.variantId));
    if (!v || v.available !== true) throw new Error('El complemento no está disponible.');
    if (candidate.expectedSku && v.sku !== candidate.expectedSku) throw new Error('No se pudo confirmar la referencia del complemento.');
    if (!Number.isInteger(candidate.unitPriceCents) || v.price !== candidate.unitPriceCents) throw new Error('El precio del complemento cambió.');
    if (!Number.isInteger(candidate.offerTotalCents) || candidate.offerTotalCents <= 0) throw new Error('La oferta aún no tiene un precio definido.');
    return v;
  }
  function validateCart(cart, cfg, parent, registry) {
    if (cart.currency && cart.currency !== cfg.currency) throw new Error('La moneda del carrito no coincide.');
    if (quantity(cart, cfg.parentVariantId) !== parent.quantity) throw new Error('El paquete principal cambió. Confirma de nuevo tu selección.');
    if (subtotal(cart, cfg.parentVariantId) > parent.totalCents) throw new Error('No se pudo confirmar el descuento del paquete principal.');
    const requested = registry.codes(cart);
    for (const code of requested) {
      const row = (cart.discount_codes || []).find(entry => entry.code.toUpperCase() === code.toUpperCase());
      if (row?.applicable === false) throw new Error('No se pudieron combinar los descuentos del carrito.');
    }
    for (const candidate of candidatesFor(cfg)) {
    const managed = ownLines(cart, candidate, cfg.context);
    if (managed.length) {
      if (quantity(cart, candidate.variantId) !== candidate.quantity || managed.length !== 1) throw new Error('La cantidad del complemento cambió. Revísala antes de pagar.');
      if (subtotal(cart, candidate.variantId) > candidate.offerTotalCents) throw new Error('No se pudo confirmar el precio del complemento.');
    }
    }
    // A gift is free only when Shopify confirms the discount and the qualifying pack.
    for(const [id, entry] of Object.entries(registry.products || {})){
      if(entry.handle!=='desodorante-corporal') continue;
      const lines=(cart.items||[]).filter(item=>variant(item)===id);
      const managed=lines.some(item=>{try{return JSON.parse(item.properties?.__kaching_bundles||'null')?.main===true;}catch(_){return false;}});
      const gifts=(cart.items||[]).filter(item=>item.properties?._omba_pack_gift===id);
      if(!managed && !gifts.length) continue;
      const q=quantity(cart,id);
      if(q>=4){if(gifts.length!==1 || gifts[0].quantity!==1 || gifts[0].final_line_price!==0) throw new Error('No pudimos confirmar tu regalo gratis. Vuelve al pack para actualizarlo.');}
      else if(gifts.length) throw new Error('Confirma tu pack para actualizar el regalo.');
    }
    if (!Number.isInteger(cart.total_price) || cart.total_price < 0) throw new Error('No se pudo confirmar el total del carrito.');
    return true;
  }
  function attach(hooks) {
    const cfg = hooks.config;
    const idle = {render(){}, refresh: () => Promise.resolve(), beforeCheckout: () => Promise.resolve()};
    // No lee productos, no toca DOM y no modifica carritos mientras esté desactivado.
    if (!cfg?.enabled || !hooks.shopify) return idle;
    if (!global.OMBACartRegistry) throw new Error('Falta el registro compartido del carrito.');
    const candidates = candidatesFor(cfg);
    if (!candidates.length || candidates.some(candidate => !Number.isInteger(candidate.unitPriceCents))) throw new Error('Complemento sin precio configurado.');
    const root = hooks.root, cartNode = root.querySelector('#cart');
    const host = document.createElement('div'); host.className = 'omba-complement-v3'; host.setAttribute('aria-live', 'polite');
    const before = cartNode.querySelector('.hueco') || cartNode.querySelector('[data-nudge]');
    before.before(host);
    const products = new Map(), pending = new Map();
    let snapshot = null, updating = false, error = '', token = 0;
    const price = cents => new Intl.NumberFormat(cfg.locale, {style:'currency', currency:cfg.currency}).format(cents / 100);
    const request = hooks.request;
    const parent = () => ({quantity: hooks.parentQuantity(), totalCents: hooks.parentTotalCents()});
    function render() {
      const sameParent = snapshot && quantity(snapshot, cfg.parentVariantId) === parent().quantity;
      const otherItems = (snapshot?.items || []).filter(item => variant(item) !== String(cfg.parentVariantId));
      // La línea gestionada ya está representada por la tarjeta seleccionada.
      const summaryItems = otherItems.filter(item => !candidates.some(candidate => variant(item) === String(candidate.variantId) && item.properties?._omba_complement === cfg.context));
      const gifts = summaryItems.filter(item => item.properties?._omba_pack_gift);
      const regular = summaryItems.filter(item => !item.properties?._omba_pack_gift);
      const ordered = regular.flatMap(item => [item, ...gifts.filter(gift => gift.properties._omba_pack_gift === variant(item))]);
      ordered.push(...gifts.filter(gift => !regular.some(item => variant(item) === gift.properties._omba_pack_gift)));
      const otherHeading = cfg.origin !== 'desodorante-corporal' && summaryItems.length ? '<p class="omba-complement-heading">También en tu carrito</p>' : '';
      let html = summaryItems.length ? otherHeading + '<div class="omba-complement-lines">' + ordered.map(item => item.properties?._omba_pack_gift && item.final_line_price===0 ? '<div class="omba-pack-gift-line"><span><small>Regalo de tu pack de Desodorante</small><strong>OMBA® Spray bucal probiótico</strong></span><strong>Gratis</strong></div>' : '<div><span>'+escape(item.product_title || item.title)+' · '+item.quantity+'</span><strong>'+price(item.final_line_price)+'</strong></div>').join('') + '</div>' : '';
      const cards = [];
      for (const candidate of candidates) {
        const existing = snapshot && quantity(snapshot, candidate.variantId) > 0;
        const managed = snapshot && ownLines(snapshot, candidate, cfg.context).length > 0;
        if ((products.has(candidate.variantId) || managed) && (!existing || managed)) {
          cards.push(cardMarkup(cfg, candidate, products.get(candidate.variantId) || {}, {checked:managed, disabled:updating || hooks.busy(), omitHeading:true}));
        }
      }
      if (cards.length) html += '<p class="omba-complement-heading">'+escape(cfg.blockTitle || 'Completa tu rutina')+'</p>'+cards.join('');
      if (error) html += '<p class="omba-complement-error" role="alert">'+escape(error)+'</p>';
      host.innerHTML = html;
      host.querySelectorAll('[data-complement-toggle]').forEach(input => input.addEventListener('change', event => toggle(event, candidates.find(candidate => String(candidate.variantId) === input.getAttribute('data-complement-toggle')))));
      const total = root.querySelector('[data-total]'), button = root.querySelector('#cGo');
      if (sameParent && !updating && !error) {
        total.textContent = price(snapshot.total_price);
        root.querySelector('#cartTotalLabel').textContent = 'Total del carrito';
        root.querySelector('#cartOtherItems').hidden = true;
        if (otherItems.length) { root.querySelector('[data-old]').textContent = ''; root.querySelector('[data-savebox]').hidden = true; }
        if (!hooks.busy()) { button.disabled = false; button.textContent = 'Finalizar compra · '+price(snapshot.total_price); }
      } else if (!hooks.busy()) {
        button.disabled = true;
        button.textContent = error ? 'Revisa tu carrito' : 'Actualizando carrito…';
      }
    }
    async function loadProduct(candidate) {
      if (products.has(candidate.variantId)) return;
      if (pending.has(candidate.variantId)) return pending.get(candidate.variantId);
      const task = (async () => {
        try {
          const response = await request('products/'+candidate.handle+'.js', undefined, 'GET');
          validateProduct(response, candidate); products.set(candidate.variantId, response);
          const photo = thumbnail(response.featured_image || response.images?.[0]);
          if (photo && global.Image) { const img = new global.Image(); img.src = photo; }
        } catch (_) { products.delete(candidate.variantId); }
        finally { pending.delete(candidate.variantId); render(); }
      })();
      pending.set(candidate.variantId, task);
      return task;
    }
    // Read-only warming starts on the PDP, before the customer opens the drawer.
    candidates.forEach(candidate => { loadProduct(candidate); });
    async function reconcile() {
      let current = await request('cart.js', undefined, 'GET');
      // A managed spray belongs only to its qualifying deodorant pack.
      // Preserve separately purchased sprays and all unrelated cart lines.
      const orphanGifts = (current.items || []).filter(item => {
        const owner = item.properties?._omba_pack_gift;
        return owner && global.OMBACartRegistry.products?.[owner]?.handle === 'desodorante-corporal' && quantity(current, owner) < 4;
      });
      if (orphanGifts.length) current = await request('cart/update.js', {updates:Object.fromEntries(orphanGifts.map(item => [item.key, 0]))});
      const codes = global.OMBACartRegistry.codes(current);
      current = await request('cart/update.js', {discount:codes.join(',')});
      validateCart(current, cfg, parent(), global.OMBACartRegistry);
      snapshot = current;
      return current;
    }
    async function refresh() {
      const generation = ++token;
      updating = true; error = ''; render();
      try {
        // Optional catalog loading must never hold the main purchase queue.
        candidates.forEach(candidate => { loadProduct(candidate); });
        await hooks.enqueue(reconcile);
      } catch (e) { error = e.message; throw e; }
      finally { if (generation === token) { updating = false; render(); } }
    }
    async function toggle(event, candidate) {
      if (!candidate || updating || hooks.busy()) return;
      const restoreFocus = event?.currentTarget === document.activeElement;
      updating = true; error = ''; render();
      try {
        await hooks.enqueue(async () => {
          let current = await request('cart.js', undefined, 'GET');
          const owned = ownLines(current, candidate, cfg.context);
          if (owned.length) {
            const updates = Object.fromEntries(owned.map(item => [item.key, 0]));
            await request('cart/update.js', {updates});
          } else if (quantity(current, candidate.variantId) === 0) {
            // Se verifica precio y disponibilidad otra vez justo antes de añadir.
            const fresh = await request('products/'+candidate.handle+'.js', undefined, 'GET');
            validateProduct(fresh, candidate); products.set(candidate.variantId, fresh);
            await request('cart/add.js', {items:[{id:candidate.variantId, quantity:candidate.quantity, properties:{_omba_complement:cfg.context, _omba_origin:cfg.origin}}]});
          }
          // Si otra pestaña lo añadió, se conserva su línea y no se duplica ni se elimina.
          await reconcile();
        });
      } catch (e) {
        error = e.message;
        // Releer después de un timeout evita convertir el reintento en un segundo AddToCart.
        try { snapshot = await request('cart.js', undefined, 'GET'); } catch (_) {}
      } finally { updating = false; render(); if (restoreFocus) host.querySelector('[data-complement-toggle="'+candidate.variantId+'"]')?.focus(); }
    }
    async function beforeCheckout() {
      await hooks.enqueue(async () => {
        const current = await request('cart.js', undefined, 'GET');
        for (const candidate of candidates) if (quantity(current, candidate.variantId)) {
          const fresh = await request('products/'+candidate.handle+'.js', undefined, 'GET');
          validateProduct(fresh, candidate);
        }
        await reconcile();
      });
    }
    return {render, refresh, beforeCheckout};
  }
  global.OMBAComplementosV3 = {attach, validateProduct, validateCart, quantity, ownLines, cardMarkup, thumbnail, candidatesFor};
})(typeof window === 'undefined' ? globalThis : window);
